const initialState = { users: [], currentUser: undefined };

export default (state = initialState, action) => {
  
  switch (action.type){
        case 'REQUEST_USERS':
          return {
            ...state
          };
          case 'RECEIVE_USERS':
            return {
              ...state,
              users: action.users
            };
        case 'ADD_USER':
          const users = [...state.users, action.user] 
          return {...state, users} 
        case 'REMOVE_USER': {
            const users = state.users.filter(({email}) => {
              return email !== action.email;
            });
            return {...state, users};
          }
        
        case 'REQUEST_CURRENT_USER_NOTIFICATIONS':
            return {
              ...state,
              currentUser: action.user
            };
        default: 
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/users.js